import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    button: {
      width: '150px',
      '& svg': {
        marginRight: '1rem',
        marginLeft: '-1rem',
      },
    },
    table: {
      minWidth: 'max-content',
      borderSpacing: '0 0.8rem',
      borderCollapse: 'separate',
      paddingRight: '1rem',

      '& > thead > tr > th': {
        border: 'none',
        padding: '1rem',
        position: 'sticky',
        top: -1,
        background: 'white',
        zIndex: 2,
        paddingLeft: '1rem',
        '& .MuiTypography-h3': {
          fontSize: '1.2rem',
        },
        '&:first-child': {
          width: '100px',
          minWidth: '100px',
        },
        '&:nth-child(2)': {
          width: '260px',
          minWidth: '260px',
        },
        '&:nth-child(3), &:nth-child(4), &:nth-child(5)': {
          width: '170px',
          minWidth: '170px',
        },

        '&:last-child': {
          width: '110px',
          minWidth: '100px',
        },
      },
    },
  }),
)
